import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/api/client";
import { IDS } from "@/constants/testIds";
import { toast } from "sonner";

export default function LoginPage() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await login(email.trim(), password);
      toast.success("Accesso effettuato");
    } catch (err) {
      const msg = formatApiErrorDetail(err?.response?.data?.detail) || "Impossibile accedere";
      setError(msg);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-screen" data-testid="login-screen">
      <section className="login-panel">
        <div className="login-box">
          <div className="login-logo">
            <div className="brand-mark">G</div>
            <div>
              <strong>GymERP</strong>
              <small>Gymnastic Design</small>
            </div>
          </div>
          <div className="eyebrow">Area riservata</div>
          <h1>Accedi al gestionale</h1>
          <p>Inserisci l'indirizzo email e la password associati al tuo account.</p>
          <form onSubmit={onSubmit} className="login-form" autoComplete="on">
            <div className="field">
              <label>Email</label>
              <input
                data-testid={IDS.loginEmail}
                type="email"
                autoComplete="username"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="field">
              <label>Password</label>
              <input
                data-testid={IDS.loginPassword}
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            {error && (
              <div className="login-error" data-testid={IDS.loginError}>
                <i className="fa-solid fa-triangle-exclamation" />&nbsp; {error}
              </div>
            )}
            <button
              className="btn primary"
              type="submit"
              disabled={busy}
              data-testid={IDS.loginSubmit}
            >
              <i className="fa-solid fa-right-to-bracket" />
              {busy ? "Accesso in corso..." : "Accedi a GymERP"}
            </button>
          </form>
          <div className="login-note">
            Sessione protetta con JWT httpOnly. Le credenziali sono verificate lato server con bcrypt.
          </div>
        </div>
      </section>
      <section className="login-visual">
        <div className="login-visual-inner">
          <div className="mini-label">Gymnastic Design · Gestionale interno</div>
          <h2>Il tuo magazzino, ordinato e sempre sotto controllo.</h2>
          <p>Gestisci prodotti grezzi, personalizzazioni, carichi, scarichi, fornitori e disponibilità da un'unica interfaccia.</p>
          <div className="feature-row">
            <div className="feature-chip"><i className="fa-solid fa-boxes-stacked" /> Magazzino dinamico</div>
            <div className="feature-chip"><i className="fa-solid fa-palette" /> Personalizzazioni</div>
            <div className="feature-chip"><i className="fa-solid fa-chart-column" /> Movimenti e scorte</div>
          </div>
        </div>
      </section>
    </div>
  );
}
